import React from "react";

const RestorePassSuccess: React.FC = () => {
  return (
    <p>Ваш пароль успешно обновлен</p>
  )
};

export default RestorePassSuccess;